import { rest } from 'msw';
import { API_ROOT } from 'configs/env-vars';
import { zipCodes } from '../mockData/zip-codes-data';

const ZipCodesApi = [rest.get(`${API_ROOT}zip-codes`, (req, res, ctx) => res(ctx.json(zipCodes)))];
export default ZipCodesApi;
